import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { cloneDeep } from 'lodash';
//import { IUser     } from "../../../typings/timetracker/timetracker";
export type IUser = any;

interface IRole {
  type: 'administrator' | 'user';
  displayName: string;
}

interface IContract {
  type: 'fixed' | 'variable';
  displayName: string;
}


@Component({
  selector: 'user-update',
  templateUrl: 'user-update.html'
})
export class UserUpdateComponent implements OnInit {

  public form: FormGroup;

  @Output() onSubmit = new EventEmitter<IUser>();

  @Input()
  get user(): IUser {
    return this._user;
  }
  set user(user) {
    this._user = cloneDeep(user);
  }

  private _user: IUser;

  public availableRoles: IRole[] = [
    {
      type: 'administrator',
      displayName: 'Administrator'
    },
    {
      type: 'user',
      displayName: 'Gebruiker'
    }
  ];

  public availableContractTypes: IContract[] = [
    {
      type: 'fixed',
      displayName: 'Vast contract'
    },
    {
      type: 'variable',
      displayName: 'Variabel'
    }
  ];


  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      fullname: [this.user.fullname, Validators.required ],
      employee_nr: [this.user.employee_nr, Validators.required ],
      tag: [this.user.tag  ],
      fixed_contract_hours: [this.user.fixed_contract_hours],
      user_role: [this.user.user_role, Validators.required ],
      contract_type: [this.user.contract_type, Validators.required ],
      bhv: [this.user.bhv ],
      active: [this.user.active ],
    });

    this.form.get('contract_type').valueChanges.subscribe( ( contractType ) => {
      const validators = [];
      const fixedContractHoursCtrl = this.form.get('fixed_contract_hours');

      if ( contractType === 'fixed' ) {
        validators.push( Validators.required );
        validators.push( Validators.min( 1 ) );
        validators.push( Validators.max( 60 ) );
      }

      fixedContractHoursCtrl.setValidators( validators );
      fixedContractHoursCtrl.updateValueAndValidity();
    });
  }

  submit(user: IUser) {
    this.onSubmit.emit(user);
  }

}



// WEBPACK FOOTER //
// ./src/components/user-update/user-update.ts